export default __webpack_public_path__ + "static/mistake-4-e2efae172513a5f0af1a7c2491da684f.png";